module.exports = "<div id=\"root\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/workflowconfig/workflowconfig.component.html
// module id = ../../../../../src/app/workflowconfig/workflowconfig.component.html
// module chunks = main